"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardInsightRuleType = exports.DashboardInsightHighlightEntityType = exports.DashboardInsightHighlightType = exports.DashboardHolidayType = exports.DashboardEntityType = void 0;
var DashboardEntityType;
(function (DashboardEntityType) {
    DashboardEntityType["Commit"] = "COMMIT";
    DashboardEntityType["Task"] = "TASK";
    DashboardEntityType["PullRequest"] = "PULL_REQUEST";
})(DashboardEntityType = exports.DashboardEntityType || (exports.DashboardEntityType = {}));
var DashboardHolidayType;
(function (DashboardHolidayType) {
    DashboardHolidayType["UNKNOWN"] = "UNKNOWN";
    DashboardHolidayType["PUBLIC_HOLIDAY"] = "PUBLIC_HOLIDAY";
    DashboardHolidayType["BANK_HOLIDAY"] = "BANK_HOLIDAY";
})(DashboardHolidayType = exports.DashboardHolidayType || (exports.DashboardHolidayType = {}));
var DashboardInsightHighlightType;
(function (DashboardInsightHighlightType) {
    DashboardInsightHighlightType["Commit"] = "COMMIT";
    DashboardInsightHighlightType["Task"] = "TASK";
    DashboardInsightHighlightType["TaskStatusChange"] = "TASK_STATUS_CHANGE";
    DashboardInsightHighlightType["PullRequest"] = "PULL_REQUEST";
})(DashboardInsightHighlightType = exports.DashboardInsightHighlightType || (exports.DashboardInsightHighlightType = {}));
var DashboardInsightHighlightEntityType;
(function (DashboardInsightHighlightEntityType) {
    DashboardInsightHighlightEntityType["Main"] = "MAIN";
    DashboardInsightHighlightEntityType["Related"] = "RELATED";
})(DashboardInsightHighlightEntityType = exports.DashboardInsightHighlightEntityType || (exports.DashboardInsightHighlightEntityType = {}));
var DashboardInsightRuleType;
(function (DashboardInsightRuleType) {
    DashboardInsightRuleType["TaskStatus"] = "TaskStatus";
})(DashboardInsightRuleType = exports.DashboardInsightRuleType || (exports.DashboardInsightRuleType = {}));
//# sourceMappingURL=dashboard-notification.js.map